export function normalizeCsvData(payload: any): any {
  if (!payload || !Array.isArray(payload)) return payload;

  const stripQuotes = (s: any): any =>
    typeof s === 'string' ? s.replace(/^"+|"+$/g, '').trim() : s;

  const normalizeKey = (key: string): string => {
    // remove aspas, trim
    let k = stripQuotes(key);
    // alinhar nomes divergentes
    if (/^Roleta$/i.test(k)) k = 'Sorteio';
    return k;
  };

  const normalizedCsv = payload.map((row: Record<string, any>) => {
    const out: Record<string, any> = {};
    for (const [rawKey, rawVal] of Object.entries(row)) {
      const key = normalizeKey(rawKey);
      const val = stripQuotes(rawVal);
      out[key] = val;
    }
    return out;
  });

  return normalizedCsv;
}